import React, { useState, useEffect } from "react";
import Header from "@Components/Header/Header";
import Footer from "@Components/Footer/Footer";
import BreadcrumbPage from "@Components/MultiForm/BreadcrumbPage/BreadcrumbPage";
import FormPage from "@Components/MultiForm/FormPage/FormPage"
import moment from "moment/dist/moment";
import ContactSection from "@Components/MultiForm/ContactSection/ContactSection";
import ScrollAnimation from "react-animate-on-scroll";
import * as qs from "query-string"
import { postFormData } from "@Components/forms/api/Api"
import axios from "axios"
import ReCaptchaBox from '@Components/forms/elements/recaptcha'
import "./bookaviewing.scss"
import $ from 'jquery/dist/jquery.min.js'
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Breadcrumb } from "react-bootstrap";
import { useStaticQuery, graphql } from "gatsby";
import { getUser } from "@starberry/myaccount-website-utils"

const BookAViewing = (props) => {
  const userData = getUser();

  const [startDate, setStartDate] = useState(
    // setHours(setMinutes(new Date(), 0), 0)
    new Date()
  )
  const recaptchaRef = React.createRef();
  const [formvalues, setFormvalues] = useState("");
  const [token, setToken] = useState("");
  const handleBack = () => window.history.back();
  useEffect(() => {
    sessionStorage.setItem('date', new Date())
    window.scrollTo(0, 0);
    // setStep(sessionStorage.getItem('step') != null ? parseInt(sessionStorage.getItem('step')) : 0)
    setName(sessionStorage.getItem('name') != null ? sessionStorage.getItem('name') : userData?.name)
    setEmail(sessionStorage.getItem('email') != null ? sessionStorage.getItem('email') : userData?.email)
    setPhone(sessionStorage.getItem('telephone') != null ? sessionStorage.getItem('telephone') : userData?.mobile)
    setTiming(sessionStorage.getItem('Timing') != null ? sessionStorage.getItem('Timing') : false)
    setStartDate(new Date())
    setDate(sessionStorage.getItem('date') != null ? sessionStorage.getItem('date') : new Date())
    
  }, []);
  const [step, setStep] = useState(0)
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState(false)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState(false)
  const [valemailError, setValEmailError] = useState(false)
  const [phone, setPhone] = useState('')
  const [phoneError, setPhoneError] = useState(false)
  const [valphoneError, setValPhoneError] = useState(false)
  const [address, setAddress] = useState('')
  const [timing, setTiming] = useState(false)
  const [date, setDate] = useState(null)
  const [submitted, stepSubmitted] = useState(false)

  const setTimingF = (event) => {
    setTiming(event)
    sessionStorage.setItem('Timing', event)
  }

  const onSelectDate = (date) => {
    sessionStorage.setItem('date', date)
  }
  const onChange = (e) => {
    sessionStorage.setItem(e.target.name, e.target.value)
    if (e.target.name === 'name') {
      setName(e.target.value)
      if (e.target.value !== "") {
        setNameError(false)
      }
      else {
        setNameError(true)
      }
    }
    if (e.target.name === 'email') {
      setEmail(e.target.value)
      if (e.target.value === "") {
        setEmailError(true)
      }
      else if (e.target.value.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null) {
        setValEmailError(true)
        setEmailError(false)
      }
      else {
        setEmailError(false)
        setValEmailError(false)
      }
    }
    if (e.target.name === 'telephone') {
      setPhone(e.target.value)
      if (e.target.value === "") {
        setPhoneError(true)
      }
      else if (e.target.value.match("^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$") === null) {
        setValPhoneError(true)
        setPhoneError(false)
      }
      else {
        setPhoneError(false)
        setValPhoneError(false)
      }
    }


  }

  const next = event => {
    if (step === 0) {
      if (!name) {
        if (!name) {
          setNameError(true)
        }
      }
      else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step + 1)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'BookAViewing-step-one',
          'formId': 'BookAViewing-step-one',
          'formName': 'BookAViewing Step One',
          'formLabel': 'BookAViewing Step One'
        });
      }
    }
    if(step === 1){
      if(!email || !phone || email.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null || phone.match("^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$") === null){
        if(!email){
          setEmailError(true)
        }
        if(email.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null){
          setValEmailError(true)
        }
        if(!phone){
          setPhoneError(true)
        }
        if(phone.match("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$") === null){
          setValPhoneError(true)
        }        
      }
      else{
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step+1)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'BookAViewing-step-two',
          'formId': 'BookAViewing-step-two',
          'formName': 'BookAViewing Step Two',
          'formLabel': 'BookAViewing Step Two'
        });
      }
    }
    else if(step === 2) {
      if(!timing || !startDate){
        stepSubmitted(true)
      }
       else{
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      setStep(step+1)
      var selectedaddress  = $("input[name=address]").val();
      $("input[name=selected_address]").val(selectedaddress);
      setDate(sessionStorage.getItem('date'))
      const formsdata = (event.target);
      event.preventDefault();
      const json = {}
      Object.keys(formsdata).map(key => (
          json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))
      json['email_temp_user'] = "book_user";
      json['email_temp_admin'] = "book_admin";
      json['formname'] = "BookAViewing";
      if (json['subject']) {
          json['formname'] = 'BookAViewing';
      }
      // json['type_of_valuation'] = sessionStorage.getItem('type_of_valuation');
      json['name'] = sessionStorage.getItem('name');
      json['email'] = sessionStorage.getItem('email');
      json['telephone'] = sessionStorage.getItem('telephone');
      json['emailtemplatephone'] = props.officeNumber
      json['display_address'] = props.address;
      json['url'] = props.url;
      json['address'] = props.address;
      json['date_time'] = moment(sessionStorage.getItem('date')).format("DD-MM-YYYY")+', '+ sessionStorage.getItem('Timing');
      json['g-recaptcha-response'] = token;
      json['search_type'] = props.search_type;
      json['property_image'] = props.image
      json['property_price'] = props.price
      json['office_crm_id'] = props.office_crm_id
      
      setFormvalues(json);
      recaptchaRef.current.execute();
         window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setStep(step+1)
        window.scrollTo(0, 0);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'BookAViewing-step-three',
          'formId': 'BookAViewing-step-three',
          'formName': 'BookAViewing Step Three',
          'formLabel': 'BookAViewing Step Three'
        });
      }

    }
    
  }

  const previous = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })

    setStep(step - 1)
    // sessionStorage.setItem('step', step - 1)

  }

  useEffect(() => {
    // Initialize Bootstarp file upload field value retain js
    // bsCustomFileInput.init()

    if (token !== '') {


      const processFromData = async () => {

        let formData = new FormData();

        formData.append('data', JSON.stringify(formvalues));

        postFormData(formData).then(apiRes => {

          const axiosOptions_email = {
            url: '/.netlify/functions/server/book_a_viewing',
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: qs.stringify(formvalues),
          }

          axios(axiosOptions_email)
            .then(response => {
              // console.log('mail sent!')
              // next()
              sessionStorage.removeItem("name")
              sessionStorage.removeItem("email")
              sessionStorage.removeItem("telephone")
              sessionStorage.removeItem("date")
              sessionStorage.removeItem("address")
              // sessionStorage.removeItem("type_of_valuation")
              sessionStorage.removeItem('sellorlet');
            })
            .catch(err => {

            }
              // console.log(err)
            );
        });

        // tracking event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'form-' + sessionStorage.getItem('sellorlet'),
          'formId': 'form-' + sessionStorage.getItem('sellorlet'),
          'formName': 'BookAViewing',
          'formLabel': 'BookAViewing'
        });

        // next()

      }
      processFromData();
    }
  }, [token]);
  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };


  return (
    <React.Fragment>
      {/* <div className=""><Header /></div> */}
      <div className="book-a-view">
      {step === 0 ? <>
        <section className="multi-form-section">
          <Container>

            
            <div className="form-container">
            <Row>
              <Col lg={12}>
                <Button type="button" onClick={props.handleClose} className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Button>
              </Col>
            </Row>
              <Row>
                <Col lg={12}>
                  <h1>Thank you for reaching out. Let’s start with your name please.</h1>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="form">
                    <Form.Group controlId="formBasicName">
                      <div className="custom-float">
                        <Form.Control className={nameError ? 'error-border' : ''} autoComplete="off" value={name} onChange={onChange} name="name" type="text" placeholder="Enter your name" required="true" />
                        <label className="plclabel">Your Name</label>
                        {nameError &&
                          <div className="error">
                            Please Enter name.
                          </div>
                        }
                      </div>
                    </Form.Group>

                    
                      <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                    

                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </>
        : step === 1 ? <>
          <section className="multi-form-section">
            <Container>


              <div className="form-container">
              <Row>
                <Col lg={12}>
                  <Button type="button" onClick={previous} className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Button>
                </Col>
              </Row>
                <Row>
                  <Col lg={12}>
                    <h1>Thanks {name}. Now we’ll need your contact details.</h1>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="form">
                      <Form.Group controlId="formBasicEmail">
                        <div className="custom-float">
                          <Form.Control className={emailError ? 'error-border' : valemailError ? 'error-border' : ''} autoComplete="off" value={email} onChange={onChange} name="email" type="email" placeholder="" required="true" />
                          <label className="plclabel">Your E-mail</label>
                          {emailError &&
                            <div className="error">
                              Please Enter Email.
                            </div>
                          }
                          {valemailError && !emailError &&
                            <div className="error">
                              Please Enter Valid Email.
                            </div>
                          }
                        </div>
                      </Form.Group>

                      <Form.Group controlId="formBasicTelephone">
                        <div className="custom-float">
                          <Form.Control maxLength={13} className={phoneError ? 'error-border' : valphoneError ? 'error-border' : ''} autoComplete="off" value={phone} onChange={onChange} name="telephone" type="text" placeholder="Enter your Telephone" required="true" />
                          <label className="plclabel">Your Telephone</label>
                          {phoneError &&
                            <div className="error">
                              Please Enter Telephone.
                            </div>
                          }
                          {valphoneError && !phoneError &&
                            <div className="error">
                              Please Enter Valid Telephone.
                            </div>
                          }
                        </div>
                      </Form.Group>
                      
                      <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                    
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </> : step === 2 ? <>
          <section className="multi-form-section">
            <Container>

              <div className="form-container">
              <Row>
                <Col lg={12}>
                  <Button type="button" onClick={previous} className="button-back btn-text-link" variant="link"><i className="icon-back"></i> Go Back</Button>
                </Col>
              </Row>
                <Row>
                  <Col lg={12}>
                    <h1>Lastly, we need your preferred date and time.</h1>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="form">
                      <Form.Group controlId="formBasicPreferredDate">
                        {/*  */}
                          <Form.Label>Preferred Date</Form.Label>
                            <DatePicker
                            className="form-control"
            selected={startDate}
            minDate={new Date()}
            onChange={date => {
              setStartDate(date) 
              onSelectDate(date)
            }}
            dateFormat="dd, MMMM yyyy"
            locale="en-gb"
          />
           {!startDate && submitted &&
                    <div className="error">
                      Please choose an option.
                    </div>
                    }

                        {/*  */}
                      </Form.Group>
                      <Form.Group >
                        
                          <Form.Label>Preferred Time</Form.Label>
                          <div className="form-button-groups grid-3">
                            <Button onClick={() => setTimingF('Morning')} variant="outline" className={timing === "Morning" ? "active outline-primary" : "outline-primary"}>Morning<br/><span>9 AM to 12 PM</span></Button>
                            <Button onClick={() => setTimingF('Afternoon')} variant="outline" className={timing === "Afternoon" ? "active outline-primary" : "outline-primary"}>Afternoon<br/><span>12 PM to 4 PM</span></Button>
                            <Button onClick={() => setTimingF('Evening')} variant="outline" className={timing === "Evening" ? "active outline-primary" : "outline-primary"}>Evening<br/><span>4 PM to 7 PM</span></Button>
                            {!timing && submitted &&
                    <div className="error">
                      Please choose an option.
                    </div>
                    }
                          </div>
                        
                      </Form.Group>
                      
                        <Button variant="primary" className="button-submit" onClick={next} >Next Step</Button>
                      

                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>

        </> :






          <ContactSection />}
          </div>
          <ReCaptchaBox
                className="py-2"
                captRef={recaptchaRef}
                key="captcha"
                handleonVerify={handleonVerify}
            />
      {/* <div className="breadcrumb-other-page"><BreadcrumbPage /></div>
      <Footer /> */}
    </React.Fragment>

  )
}



export default BookAViewing